import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { GROUPING_NAME_CONFIG } from './base/grouping-name-config';

export const groupingNameRoutes: Routes = [
  {
    path: GROUPING_NAME_CONFIG.routePath,
    canActivate: [roleGuard('ADMIN_MASTER')],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/grouping-name-list-page/grouping-name-list-page.component'
          ).then((m) => m.GroupingNameListPageComponent),
        canActivate: [roleGuard('ADMIN_MASTER')],
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/grouping-name-detail-page/grouping-name-detail-page.component'
              ).then((m) => m.GroupingNameDetailPageComponent),
          },
        ],
      },
    ],
  },
];
